// You can customize the template with the help of this file

//Template config options
const themeConfig = {
  app: {
    appName: "DMIS",
    // appLogoImage: require("@src/assets/images/logo/logo.svg").default,
    appLogoDarkImage:
      require("@src/assets/images/logo/logo-h-with-text-dark.png").default,
    appLogoLightImage:
      require("@src/assets/images/logo/logo-h-with-text-light.png").default
  },
  layout: {
    isRTL: true,
    skin: "light", // light, dark, bordered, semi-dark
    type: "vertical", // vertical, horizontal
    contentWidth: "boxed", // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: false
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: "sticky", // static , sticky , floating, hidden
      backgroundColor: "white" // BS color options [primary, success, etc]
    },
    footer: {
      type: "hidden" // static, sticky, hidden
    },
    customizer: true,
    scrollTop: true, // Enable scroll to top button
    toastPosition: "top-center" // top-left, top-center, top-right, bottom-left, bottom-center, bottom-right
  }
}

export default themeConfig
